// @tennis-matches/services/governance
// Server-RPC: vor „meine Bindings“ identische verifizierte E-Mail → auth.uid() umhängen (SECURITY DEFINER).

import { getSupabaseClient } from "../supabase/index.js";
import { setAuthDebugRpcError } from "../auth/auth-debug-state.js";

const SCHEMA = "app_config";
const RPC = "relink_my_governance_identity_for_verified_session_email";

function __db(supabase) {
  return supabase && typeof supabase.schema === "function" ? supabase.schema(SCHEMA) : supabase;
}

function __resolveSupabaseTarget() {
  if (typeof globalThis !== "undefined") {
    const ttb = String(globalThis.__TTB_ENV__?.TM_SUPABASE_TARGET || "").toLowerCase();
    if (ttb) return ttb;
  }
  if (typeof import.meta !== "undefined" && import.meta.env) {
    return String(
      import.meta.env.VITE_TM_SUPABASE_TARGET || import.meta.env.TM_SUPABASE_TARGET || ""
    ).toLowerCase();
  }
  return "";
}

function __shouldPreferPublicAppConfigRpc() {
  const target = __resolveSupabaseTarget();
  return target === "test" || target === "staging" || target === "preview";
}

async function __rpcRelinkGovernanceIdentity(supabase) {
  if (__shouldPreferPublicAppConfigRpc()) {
    return supabase.rpc(RPC);
  }
  const db = __db(supabase);
  const primary = await db.rpc(RPC);
  if (!primary.error || !__isMissingRpcOrSchemaError(primary.error)) {
    return primary;
  }
  return supabase.rpc(RPC);
}

function __isMissingRpcOrSchemaError(error) {
  const msg = String(error?.message || "").toLowerCase();
  const code = String(error?.code || "");
  return (
    code === "42883" ||
    code === "PGRST202" ||
    code === "PGRST106" ||
    code === "P0001" ||
    msg.includes("does not exist") ||
    msg.includes("404") ||
    msg.includes("invalid schema") ||
    (msg.includes("schema") && msg.includes("not found"))
  );
}

/**
 * Ruft `app_config.relink_my_governance_identity_for_verified_session_email` auf (bestehende Bindings nur).
 * @returns {Promise<{ ok: boolean, skipped?: boolean, reason?: string, result?: unknown, error?: unknown }>}
 */
export async function relinkGovernanceIdentityForSessionEmailRemote() {
  const supabase = await getSupabaseClient();
  if (!supabase) return { ok: false, reason: "no-supabase" };
  if (typeof supabase.rpc !== "function") return { ok: false, reason: "no-rpc-client" };

  try {
    const { data, error } = await __rpcRelinkGovernanceIdentity(supabase);
    if (error) {
      if (__isMissingRpcOrSchemaError(error)) {
        return { ok: true, skipped: true, reason: "rpc-missing", error };
      }
      setAuthDebugRpcError(RPC, error);
      return { ok: false, reason: "rpc-error", error };
    }
    return { ok: true, result: data ?? null };
  } catch (e) {
    setAuthDebugRpcError(RPC, e);
    return { ok: false, reason: "exception", error: e };
  }
}
